module.exports = __webpack_public_path__ + "static/media/workAntihumidity2.0bcd0042.jpg";